export const CHECKOUT_FORM_NAME = 'checkoutForm' as const;

export enum CheckoutFormSection {
    contactInfo = 'contactInfo',
    attendees = 'attendees',
    tosCheckbox = 'tosCheckbox',
    payment = 'payment',
}
